import bikeImage from "./images/rower-cube-trapeze.webp";
import bikeImage1 from "./images/rower-cube-533121-reaction-hybrid-performance-500.webp";
import bikeImage2 from "./images/rower-elektryczny-cube-reaction-hybrid-pro-500-2256345-1080x636.webp";
import bikeImage3 from "./images/hero-skl-focarini-petrol.webp";
import bikeImage4 from "./images/invader-707-skl-focarini-lime.webp";
import bikeImage5 from "./images/raptor-nodisc-skl-focarini-black.webp";
import trailerImage from "./images/przyczepka-rowerowa-hamax-ixplorer.webp";
import seatImage from "./images/polisport-fotelik.webp";
import helmetImage from "./images/kask.webp";

export const bikeList = [
  { id: 1, image: bikeImage },
  { id: 2, image: bikeImage1 },
  { id: 3, image: bikeImage2 },
  { id: 4, image: bikeImage3 },
  { id: 5, image: bikeImage4 },
  { id: 6, image: bikeImage5 },
  { id: 7, image: trailerImage },
  { id: 8, image: seatImage },
  { id: 9, image: helmetImage },
];